import KitchenTap from './KitchenTapContainer';

export default KitchenTap;
